export default {
    patients: state => {
        return state.patients;
    },
    roles: (state) => {
        return state.roles;
      },
    role: (state) => {
        return state.role;
      },
    firstName: state => {
        return state.firstName;
    },
    lastName: state => {
        return state.lastName;
    },
    mobile: state => {
        return state.mobile;
    },
    dateOfBirth: state => {
        return state.dateOfBirth;
    },
    mobileCountryId: state => {
        return state.mobileCountryId;
    },
    spouseFirstName: state => {
        return state.spouseFirstName;
    },
    spouseLastName: state => {
        return state.spouseLastName;
    },
    spouseNationalCode: state => {
        return state.spouseNationalCode;
    },
    spouseCountryId: state => {
        return state.spouseCountryId;
    },
    spouseIdentityCode: state => {
        return state.spouseIdentityCode;
    },
    fatherName: state => {
        return state.fatherName;
    },
    nationalCode: state => {
        return state.nationalCode;
    },
    otherCode: state => {
        return state.otherCode;
    },
    mobiles: state => {
        return state.mobiles;
    },
    country: state => {
        return state.country;
    },
    city: state => {
        return state.city;
    },
    province: state => {
        return state.province;
    },
    issuedProvince: state => {
        return state.issuedProvince;
    },
    issuedCity: state => {
        return state.issuedCity;
    },
    birthProvince: state => {
        return state.birthProvince;
    },
    birthCity: state => {
        return state.birthCity;
    },
    gender: state => {
        return state.gender;
    },
    genders: state => {
        return state.genders;
    },
    maritalStatus: state => {
        return state.maritalStatus;
    },
    referralWays: state => {
        return state.referralWays;
    },
    referralWay: state => {
        return state.referralWay;
    },
    referrerName: state => {
        return state.referrerName;
    },
    referrerUser: state => {
        return state.referrerUser;
    },
    referrerUsers: state => {
        return state.referrerUsers;
    },
    referrerAddress: state => {
        return state.referrerAddress;
    },
    referrerNationalCode: state => {
        return state.referrerNationalCode;
    },
    maritalStatuses: state => {
        return state.maritalStatuses;
    },
    addresses: state => {
        return state.addresses;
    },
    addressTypes: state => {
        return state.addressTypes;
    },
    email: state => {
        return state.email;
    },
    phones: state => {
        return state.phones;
    },
    patientToEdit: state => {
        return state.patientToEdit;
    },
    usersToAdd: state => {
        return state.usersToAdd;
    },
    spouses: state => {
        return state.spouses;
    },
    total: state => {
        return state.total;
    },
   
}